import React,{useEffect,useState} from "react";
import {Box,Typography,Table,TableHead,TableRow,TableCell,TableBody,Button,TextField,Card,CardContent} from "@mui/material";
import api from "../../api/api";

export default function LeaveMaintenance(){

const [rows,setRows]=useState([]);

const [form,setForm]=useState({
name:"",
days_per_year:0
})

useEffect(()=>{loadData()},[])

const loadData=async()=>{
const res=await api.get("/leave-types");
setRows(res.data);
}

const createType=async()=>{
await api.post("/leave-types",form);
loadData();
}

const deleteType=async(id)=>{
await api.delete(`/leave-types/${id}`);
loadData();
}

return(

<Box p={4}>

<Typography variant="h5" mb={3}>Leave Maintenance</Typography>

<Card sx={{mb:3}}>
<CardContent>

<TextField
label="Leave Name"
value={form.name}
onChange={(e)=>setForm({...form,name:e.target.value})}
sx={{mr:2}}
/>

<TextField
label="Days Per Year"
value={form.days_per_year}
onChange={(e)=>setForm({...form,days_per_year:e.target.value})}
sx={{mr:2}}
/>

<Button variant="contained" onClick={createType}>Add</Button>

</CardContent>
</Card>

<Table>

<TableHead>
<TableRow>
<TableCell>Name</TableCell>
<TableCell>Days</TableCell>
<TableCell>Action</TableCell>
</TableRow>
</TableHead>

<TableBody>

{rows.map(r=>(
<TableRow key={r.id}>
<TableCell>{r.name}</TableCell>
<TableCell>{r.days_per_year}</TableCell>
<TableCell>
<Button onClick={()=>deleteType(r.id)}>Deactivate</Button>
</TableCell>
</TableRow>
))}

</TableBody>

</Table>

</Box>

)

}